import api from "./api";

export const listPendingActions = async (status) => {
  const params = status ? { status } : {};
  const { data } = await api.get("/ai-tools/pending-actions", { params });
  return data;
};

export const approvePendingAction = async (id) => {
  const { data } = await api.post(`/ai-tools/pending-actions/${id}/approve`);
  return data;
};

export const rejectPendingAction = async (id, reason) => {
  const { data } = await api.post(`/ai-tools/pending-actions/${id}/reject`, {
    reason,
  });
  return data;
};

const pendingActionsApi = {
  listPendingActions,
  approvePendingAction,
  rejectPendingAction,
};

export default pendingActionsApi;
